import { locationSurchargeType } from "./location-surcharge-type.const";
import { LocationSurcharge } from "./location-surcharge.type";
import { QuoteLocationSurcharge } from "../../quote/quote-surcharge/quote-location-surcharge.type";
import { LocationSurchargeMapper } from "./location-surcharge.mapper";
import { Carrier } from "../../carrier/carrier.model";
import { CrudAbstractModel } from "../../crud-abstract/crud-abstract.model";
import { SurchargeType } from "app/surcharge-type/surcharge-type.model";
import { SurchargeTypeMapper } from "app/surcharge-type/surcharge-type.mapper";
import { surchargeAssignment } from "app/quote/quote-surcharge/assignment.const";

export class LocationSurchargeBase extends CrudAbstractModel {
  constructor(
    public id: number,
    public discriminator: string,
    public name: string,
    protected carrier: Carrier,
    protected type: string = locationSurchargeType.destination,
    protected assignment: string = "",
    protected quoteLocationSurcharges?: QuoteLocationSurcharge[],
    public currency: string = "USD",
    public surchargeType?: SurchargeType,
    public debugInfo?: string,
    public chargedFor?: string,
    public internalNote?: string,
    public sort?: number,
    public isBusy?: boolean,
  ) {
    super(id);
  }

  public getId(): number {
    return this.id;
  }

  public getDiscriminator() {
    return this.discriminator;
  }

  public setId(id: number): void {
    this.id = id;
  }

  public getName(): string {
    return this.name;
  }

  public setName(name: string): void {
    this.name = name;
  }

  public get editedName(): string {
    const quoteSurcharge = this.getFirstQuoteLocationSurcharge();

    return quoteSurcharge && quoteSurcharge.getName()
      ? quoteSurcharge.getName()
      : this.getName();
  }

  public get debugInfoParsed(): string {
    if (this.debugInfo) {
      this.debugInfo = this.debugInfo.replace(
        /{{r:([0-9]+)}}{{ro:([0-9]+)}}{{wb:([0-9a-z]+)}}/gm,
        "<a href='/rate/fcl/contract/$1?route=$2&weightBracket=$3' target='_blank'><i class='pi pi-external-link'></i></a>",
      );
      this.debugInfo = this.debugInfo.replace(
        /{{l:([0-9]+)}}/gm,
        "<a href='/location/$1' target='_blank'><i class='pi pi-external-link'></i></a>",
      );
      return this.debugInfo.replace(
        /{{r:([0-9]+)}}/gm,
        "<a href='/rate/fcl/contract/$1' target='_blank'><i class='pi pi-external-link'></i></a>",
      );
    }
  }

  public set editedName(name: string) {
    if (this.haveQuoteLocationSurcharges()) {
      this.getFirstQuoteLocationSurcharge().setName(name);
      this.setName(name);
    } else {
      this.setName(name);
    }
  }

  public get editableInternalNote(): string {
    const quoteSurcharge = this.getFirstQuoteLocationSurcharge();

    return quoteSurcharge && quoteSurcharge.getInternalNote()
      ? quoteSurcharge.getInternalNote()
      : this.getInternalNote();
  }

  public set editableInternalNote(internalNote: string) {
    if (this.haveQuoteLocationSurcharges()) {
      this.getFirstQuoteLocationSurcharge().setInternalNote(internalNote);
    }
  }

  public getCarrier(): Carrier {
    return this.carrier;
  }

  public getType(): string {
    return this.type;
  }

  public getInternalNote(): string {
    return this.internalNote;
  }

  public getAssignment(): string {
    return this.assignment;
  }

  public setAssignment(assignment: string): void {
    this.assignment = assignment;
  }

  public getCurrency(): string {
    return this.currency;
  }

  public getRequestParams() {
    return {
      carrier: this.getCarrier().getId(),
      name: this.getName(),
      type: this.getType(),
    };
  }

  public getQuoteLocationSurcharges(): QuoteLocationSurcharge[] {
    return this.quoteLocationSurcharges;
  }

  public getFirstQuoteLocationSurcharge(): QuoteLocationSurcharge {
    if (this.haveQuoteLocationSurcharges()) {
      return this.quoteLocationSurcharges[0];
    }
  }

  public setQuoteLocationSurcharges(
    quoteLocationSurcharges: QuoteLocationSurcharge[],
  ): void {
    this.quoteLocationSurcharges = quoteLocationSurcharges;
  }

  public haveQuoteLocationSurcharges(): boolean {
    return this.getQuoteLocationSurcharges()
      ? this.getQuoteLocationSurcharges().length > 0
      : false;
  }

  public getSurchargeType(): SurchargeType {
    return this.surchargeType;
  }

  public get info(): string | null {
    return this.surchargeType
      ? this.surchargeType.getInternalDescription()
      : null;
  }

  public getClone(): LocationSurcharge {
    return LocationSurchargeMapper.map({
      id: this.id,
      discriminator: this.discriminator,
      name: this.name,
      carrier: this.carrier,
      type: this.type,
      assignment: this.assignment,
      quoteLocationSurcharges: this.quoteLocationSurcharges,
      currency: this.currency,
      chargedFor: this.chargedFor,
      debugInfo: this.debugInfo,
      surchargeType: SurchargeTypeMapper.map(this.getSurchargeType()),
    });
  }

  public isValid(): boolean {
    if (this.assignment == surchargeAssignment.quote) {
      return this.name && this.name !== "" ? true : false;
    } else {
      return (this.name && this.name !== "") || this.getSurchargeType()
        ? true
        : false;
    }
  }
}
